
//Modal
export const SET_MODAL_CONTENT = "SET_MODAL_CONTENT";

//Filter
export const TOGGLE_MODAL = "TOGGLE_MODAL";
export const FILTER_CATEGORY = "FILTER_CATEGORY";
export const CHANGE_FILTER_STATE = "CHANGE_FILTER_STATE";

